






















































import { CvValue, UpsertProduct, Product } from '@/models'
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import ApiClient from '@/services/api-client'
import { CV_VALUE_PRODUCT_STATUS_TYPE } from '@/utils/constants'
import { CvValueUtils } from '@/utils/cv-value-utils'
import { ActionTypes } from '@/store/action-types'

@Component
export default class UpsertProductStatusTypeModal extends Vue {
  @Prop({ required: false }) productUpdate: Product

  private product: UpsertProduct = {
    id: '0',
    name: '',
    code: '',
    type: '',
    editorialProject: '',
    country: '',
    metadata: {},
    statusType: '',
    workType: ''
  }

  private statusType: CvValue[] = []

  get statusTypeSelect() {
    return [
      { codeId: '', name: this.$i18n.t('update_product_status_type_modal_component.status_type_placeholder') as string },
      ...this.statusType
    ]
  }

  @Watch('productUpdate', { deep: true })
  onProductUpdateChanged() {
    this.resetForm()
  }

  hideModal() {
    this.clearForm()
    this.$bvModal.hide('UpsertProductStatusTypeModal')
  }

  created() {
    this.loadStatusType()
  }

  private async loadStatusType() {
    this.statusType = await CvValueUtils.getCvValuesByType(CV_VALUE_PRODUCT_STATUS_TYPE)
  }

  public UpsertProductStatusType(): void {
    ApiClient.putProduct(this.product)
      .then((product: Product) => {
        this.$emit('productCreated', product)
        this.hideModal()
        this.clearForm()
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('update_product_status_type_modal_component.title'),
          variant: 'success',
          message: this.$t('update_product_status_type_modal_component.feedback_message_success')
        })
      })
      .catch((e) => {
        this.$store.dispatch(ActionTypes.SHOW_TOAST, {
          title: this.$t('feedback.error_title_generic'),
          variant: 'danger',
          message: this.$t('feedback.error_message_generic') + '. ' + e.response.data.message
        })
      })
  }

  private resetForm() {
    this.clearForm()

    if (this.productUpdate != null && this.productUpdate.id != null) {
      this.product.id = this.productUpdate.id
      this.product.code = this.productUpdate.code
      this.product.name = this.productUpdate.name
      this.product.type = this.productUpdate.type
      this.product.code = this.productUpdate.code
      if (this.productUpdate.editorialProject) {
        this.product.editorialProject = this.productUpdate.editorialProject
      }
      if (this.productUpdate.country) {
        this.product.country = this.productUpdate.country
      }
      this.product.metadata = Object.assign(this.product.metadata, this.productUpdate.metadata)
      if (this.productUpdate.statusType) {
        this.product.statusType = this.productUpdate.statusType
      }
      if (this.productUpdate.workType) {
        this.product.workType = this.productUpdate.workType
      }
    }
  }

  private clearForm() {
    this.product.id = ''
    this.product.code = ''
    this.product.name = ''
    this.product.code = ''
    this.product.type = ''
    this.product.editorialProject = ''
    this.product.country = ''
    this.product.metadata = {}
    this.product.statusType = ''
    this.product.workType = ''
  }
}
